<template>
  <div class="t-card">
    <div v-if="pagination">
      <h5 class="t-card--number">
        <div>{{ pagination.activeTaskCount }}</div>
        <div class="t-card--small-text" style="margin-bottom: 1rem; ">
          <router-link to="/account-tasks" tag="span">
            <span class="hand highlight-text">{{ $t("common.view-all") }}</span>
          </router-link>
        </div>
      </h5>

      <div class="t-card--small-text" style="margin-bottom: 1rem;">{{ $t("task.active") }}</div>

      <div class="progress-field">
        <div class="d-flex justify-content-between">
          <div class="progress-field--number">{{ pagination.completedTaskCount }} {{ $t("task.completed") }}</div>

          <div class="progress-field--percent">{{ completionRate }} %</div>
        </div>
        <div class="progress-field--progress-bar">
          <div class="progress-field--bar" :style="{ width: completionRate + '%' }"></div>
        </div>
      </div>
    </div>
    <div v-if="pagination">
      <div class="search--input-container mb-4">
        <i class="search--icon iconoir-search"></i>
        <input v-model="nameFilter" class="search--input" type="text" :placeholder="$t('task.search')" />
      </div>

      <div v-if="pagination">
        <div v-for="task in pagination.docs" :key="task._id">
          <kanban-card :task="task" />
        </div>
      </div>
      <empty width="100px" v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
        <h5 class="text-center" id="myText">
          {{ $t("task.empty") }}
        </h5>
      </empty>
      <div class="d-flex justify-content-center">
        <template>
          <div class="d-flex justify-content-center my-3">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="4" size="sm"></b-pagination>
            </ul>
          </div>
        </template>
      </div>
    </div>

    <content-loading v-if="isLoading" />
    <task-detail />
  </div>
</template>

<script>
import KanbanCard from "@cc/task/kanban-card";

export default {
  components: { KanbanCard },
  data() {
    return {
      nameFilter: undefined,
      request: {
        options: { page: 1, limit: 2, sort: { name: "asc" } },
        query: {},
      },
    };
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceMixin(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      const localizedField = "name." + this.currentLanguage; //only for myTaskRequest
      if (n) {
        this.request.query = { ...this.request.query, [localizedField]: { value: n } };
      } else {
        this.request.query[localizedField] = null;
        delete this.request.query[localizedField];
      }
    },
    showTaskDetailModal: {
      handler() {
        this.paginate();
      },
    },
  },

  computed: {
    pagination() {
      return this.$store.getters["task/myTasksPagination"];
    },
    isLoading() {
      return this.$store.getters[`task/isMyTasksLoading`];
    },
    showTaskDetailModal() {
      return this.$store.getters[`task/showTaskDetailModal`];
    },
    completionRate() {
      return this.pagination.total == 0 ? 0 : Math.floor((this.pagination.completedTaskCount / this.pagination.total) * 100);
    },
  },

  methods: {
    async paginate() {
      await this.$store.dispatch("task/fetchCurrentUserAssignedTask", {
        ...this.request,
        query: {
          ...this.request.query,
          status: { value: ["APPROVAL", "IN_PROGRESS", "TODO", "NOT_FIT", "UNWORKED"], isObject: true },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.highlight-text {
  &:hover {
    color: black;
    font-weight: 500;
  }
}
</style>
